// Messaging API. Clients/reps talk to internal staff; staff reply from a shared inbox.
import { api } from './client.js';

export const fetchThreads = () => api.get('/messages/threads').then((r) => r.data.threads);
export const fetchThread = (id) => api.get(`/messages/threads/${id}`).then((r) => r.data);
export const sendMessage = (body) => api.post('/messages', body).then((r) => r.data);
export const fetchUnreadCount = () => api.get('/messages/unread-count').then((r) => r.data.count);
